import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AccountCard from '../../../components/Settings/AccountCard'
import PermissionList from '../../../components/Settings/PermissionList'
import RecentActivityList from '../../../components/RecentActivityList'
import BackLink from '../../../components/Shared/BackLink'
import LoadingSpinner from '../../../components/Shared/LoadingSpinner'
import EditPermissionForm from '../../../components/Settings/EditPermissionForm'
import CloudFlyerAPI from '../../../api/CloudFlyerAPI'
import { message, Modal, Form} from 'antd'
import { receiveError } from '../../../api/http'
import { fetchRoles } from '../../../actions/roles'
import './index.scss'

class UserPage extends React.Component {

  fakeRecentActivities = [
    {
      id: 1,
      activity_date: new Date(),
      type: 'download',
      message: 'Uploaded 23 files through CloudFlyer Transfer'
    },
    {
      id: 2,
      activity_date: new Date(),
      type: 'upload',
      message: 'Downloaded 56 files through CloudFlyer Transfer'
    },
    {
      id: 3,
      activity_date: new Date(),
      type: 'download',
      message: 'Uploaded 42 files through CloudFlyer Transfer'
    }
  ]

  constructor(props) {
    super()
    this.state = {
      loading: true,
      modalVisible: false,
      unit:'Bytes',
      quota:0,
      userAcls: [],
      recentActivities: [],
      permissions: [],
      roles: [],
      user: null,
      selectedUserAcl: null
    }

    this.getUserPermissions = this.getUserPermissions.bind(this)
    this.toggleUserAclEnabled = this.toggleUserAclEnabled.bind(this)
    this.handleUserPermissionsSave = this.handleUserPermissionsSave.bind(this)
    this.changeUserRole = this.changeUserRole.bind(this)
  }

  componentDidMount() {
    const { id: userId } = this.props.match.params
    this.setState({loading: true})
    this.props.fetchRoles()

    return Promise.all([
      CloudFlyerAPI.user_account.fetchOne(userId),
      CloudFlyerAPI.user_account.acls.fetchAll(userId)
    ])
      .then(([userData, userAclsData]) => {
        const { data: user } = userData
        const { data: userAcls } = userAclsData
        this.setState({
          user,
          userAcls,
          loading: false
        })
      })
      .catch(this.handleError)
  }

  componentWillReceiveProps({ roles }) {
    if (roles.error) {
      message.error(roles.error)
    } else if (roles.items !== null) {
      this.setState({
        roles: roles.items.filter(r => r.title !== 'Owner')
      })
    }
  }

  getUserPermissions(userAclId) {
    this.setState({
      selectedUserAcl: userAclId
    })
    CloudFlyerAPI
      .user_account
      .permissions
      .fetchByUserAcl(userAclId)
      .then(({ data }) => {
        this.setState({
          userPermissions: data,
          modalVisible: true
        })
      })
      .catch(this.handleError)
  }

  toggleUserAclEnabled(userAclId, enabled) {
    CloudFlyerAPI
      .user_account
      .acls
      .toggleEnabled(userAclId, enabled)
      .then(() => {
        const userAcls = this.state.userAcls.map(acl => {
          if (acl.id === userAclId) {
            acl = { ...acl, enabled }
          }
          return acl
        })
        this.setState({
          userAcls
        })
      })
      .catch(this.handleError)
  }

  handleError(err) {
    const { message } = receiveError(null, err)
    message.error(message)
  }

  handleUserPermissionsSave() {
    console.log(selectedUserAcl, userPermissions)

    const { selectedUserAcl, userPermissions } = this.state

    this.props.form.validateFields((err, values) => {
      if (!err) {
        return Promise.all(Object.keys(values).map(id => {
          const [attribute] = Object.keys(values[id])
          return CloudFlyerAPI
            .user_account
            .permissions
            .updateOne(selectedUserAcl, id, {
            attribute,
            value: values[id][attribute]
          })
        }))
          .then(() => {
            this.setState({
              modalVisible: false,
              selectedUserAcl: null
            })
          })
          .catch(this.handleError)
      }
    })
  }

  changeUserRole(role_id) {
    Modal.confirm({
      title: 'Info',
      content: (
        <div>
          <p>Changing a user role will reset his permissions to the default settings.</p>
          <p>Are you sure to perform this operation?</p>
        </div>
      ),
      onOk: () => {
        const { user, roles } = this.state
        role_id = parseInt(role_id)
        return CloudFlyerAPI
          .user_account
          .updateOne(user.id, {
            role_id
          })
          .then(() => {
            message.success('Role successfully updated.')
            this.componentDidMount()
          })
          .catch(this.handleError)
      }
    })
  }

  on_change = (value, nev)=>{
    console.log(value, nev)
    console.log(value, nev)
  }

  render() {
    const {
      loading, user, userAcls, userPermissions, recentActivities, roles,
      modalVisible, selectedUserAcl, unit, quota
      } = this.state

    const { getFieldDecorator } = this.props.form

    if (loading) return <LoadingSpinner />

    const { title: userRole } = user.role

    console.log(unit, quota)
    return (
      <div className='user-container'>
        <BackLink to='/users' text='Go back to users' />
        <div className='user-page'>
          <AccountCard className='account-card round-corner' user={user} userRole={userRole} />
          <PermissionList
            user={this.props.user}
            roles={roles} acls={userAcls}
            userRole={userRole} selectedAcl={selectedUserAcl}
            getPermissions={this.getUserPermissions}
            toggleAclEnabled={this.toggleUserAclEnabled}
            changeUserRole={this.changeUserRole} />
          <RecentActivityList recentActivities={recentActivities} />
        </div>
        {modalVisible &&
          <Modal
            title='Service Permissions'
            visible={modalVisible}
            onOk={this.handleUserPermissionsSave}
            onCancel={() =>
              this.setState({
                modalVisible: !modalVisible,
                selectedUserAcl: null
              })
            }>
            <EditPermissionForm
              permissions={userPermissions}
              unit={unit}
              quota={quota}
              on_change={this.on_change}
              getFieldDecorator={getFieldDecorator} />
          </Modal>}
      </div>
    )
  }
}

UserPage = Form.create()(UserPage)

function mapStateToProps({ roles, auth:{user} }) {
  return { roles, user }
}

function mapDispatchToProps(dispatch) {
  return {
    fetchRoles: bindActionCreators(fetchRoles, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserPage)
